import React, { useEffect, useState } from "react";

import {
  CheckBoxWrapper,
  Details,
  Dimensions,
  // More,
  Name,
  Teams,
  UploadedOn,
  UploadedOnSort,
} from "./styles";
import { ThreeDots } from "react-bootstrap-icons";

import { DatasetRow } from "../DatasetRow";
import { NewDatasetDTO } from "../../models/Datasets";
import { CheckBox } from "../Inputs/CustomCheckbox/CheckBox";
import { TableContainer, TableFilters, TableHead, TableHeadWrapper } from "../UserManagementComponents/Users/UsersList/styled";
import { handleColumnClick } from "../UserManagementComponents/utils/usersList";
import { IActiveFilters, ILastAction, IMenuData } from "../UserManagementComponents/Users/UsersList";
import TableValuesFilter from "../TableValuesFilter";
import UsersTableMenu from "../UsersTableMenu";
import { applyFilters } from "../TableValuesFilter/utils/filters";

export const DatasetsList = ({ items }: any) => {
  const [columnMenu, setColumnMenu] = useState<IMenuData | null>(null);
  const [isOpenFilter, setIsOpenFilter] = useState<keyof NewDatasetDTO | null>(null);
  const [activeFilters, setActiveFilters] = useState<
    IActiveFilters<NewDatasetDTO>
  >({});
  const [checkAll, setCheckAll] = useState<boolean>(false);
  const [lastAction, setLastAction] = useState<ILastAction>({});
  const [list, setList] = useState<NewDatasetDTO[]>(items);

  useEffect(() => {
    const newData = applyFilters({
      data: items,
      activeFilters,
    });

    setList(newData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilters]);

  return (
    <TableContainer>
      <TableHeadWrapper>
        <TableHead>
          <CheckBoxWrapper>
            <CheckBox
              checked={checkAll}
              onChange={(e) => setCheckAll(e.target.checked)}
            />
          </CheckBoxWrapper>
          <Name>
            Name
            {/*<ThreeDots onClick={(event) =>*/}
            {/*  setColumnMenu(handleColumnClick({ event, key: "name" }))*/}
            {/*} />*/}
          </Name>
          <Dimensions>
            Dimensions
            {/*<ThreeDots onClick={(event) =>*/}
            {/*  setColumnMenu(handleColumnClick({ event, key: "fields" }))*/}
            {/*} />*/}
          </Dimensions>
          <Teams>
            Teams
            {/*<ThreeDots onClick={(event) =>*/}
            {/*  setColumnMenu(handleColumnClick({ event, key: "teams" }))*/}
            {/*} />*/}
          </Teams>
          <UploadedOn>
            Uploaded on
            {/*<UploadedOnSort onClick={(event) =>*/}
            {/*  setColumnMenu(handleColumnClick({ event, key: "createdAt" }))*/}
            {/*}*/}
            {/*/>*/}
          </UploadedOn>

          {/* <Details>
          </Details> */}
        </TableHead>
        {/*<TableFilters>*/}
        {/*  <CheckBoxWrapper $noPadding />*/}
        {/*  <Name $noPadding>*/}
        {/*    <TableValuesFilter*/}
        {/*      keyName={"name"}*/}
        {/*      filter={false}*/}
        {/*      dataList={items}*/}
        {/*      setIsOpenFilter={setIsOpenFilter}*/}
        {/*      isOpenFilter={isOpenFilter}*/}
        {/*      activeFilters={activeFilters}*/}
        {/*      setActiveFilters={setActiveFilters}*/}
        {/*    />*/}
        {/*  </Name>*/}
        {/*  <Dimensions $noPadding>*/}
        {/*    <TableValuesFilter*/}
        {/*      keyName={"fields"}*/}
        {/*      filter={false}*/}
        {/*      dataList={items}*/}
        {/*      setIsOpenFilter={setIsOpenFilter}*/}
        {/*      isOpenFilter={isOpenFilter}*/}
        {/*      activeFilters={activeFilters}*/}
        {/*      setActiveFilters={setActiveFilters}*/}

        {/*    />*/}
        {/*  </Dimensions>*/}
        {/*  <Teams $noPadding>*/}
        {/*    <TableValuesFilter*/}
        {/*      keyName={"teams" as any}*/}
        {/*      filter={false}*/}
        {/*      dataList={items}*/}
        {/*      setIsOpenFilter={setIsOpenFilter}*/}
        {/*      isOpenFilter={isOpenFilter}*/}
        {/*      activeFilters={activeFilters}*/}
        {/*      setActiveFilters={setActiveFilters}*/}

        {/*    />*/}
        {/*  </Teams>*/}
        {/*  <UploadedOn $noPadding>*/}
        {/*    <TableValuesFilter*/}
        {/*      keyName={"createdAt"}*/}
        {/*      filter={false}*/}
        {/*      disabled*/}
        {/*      dataList={items}*/}
        {/*      setIsOpenFilter={setIsOpenFilter}*/}
        {/*      isOpenFilter={isOpenFilter}*/}
        {/*      activeFilters={activeFilters}*/}
        {/*      setActiveFilters={setActiveFilters}*/}
        {/*    />*/}
        {/*  </UploadedOn>*/}
        {/*  /!* <Details $noPadding /> *!/*/}
        {/*</TableFilters>*/}
      </TableHeadWrapper>
      {items?.map((dataset: NewDatasetDTO) => (
        <DatasetRow
          id={dataset.id}
          name={dataset.name}
          createdAt={dataset.createdAt}
          fields={dataset.fields}
          filePath={dataset.filePath}
          updatedAt={dataset.updatedAt}
          selectAll={checkAll}
          key={dataset.id}
        />
      ))}
      {columnMenu && (
        <UsersTableMenu
          lastAction={lastAction}
          setLastAction={setLastAction}
          columnMenu={columnMenu}
          setColumnMenu={setColumnMenu}
          usersData={list}
          setUsersList={setList}
        />
      )}
    </TableContainer>
  );
};
